let smoother = null;

export const setSmoother = (instance) => {
	smoother = instance;
};

export const getSmoother = () => smoother;
